import React from 'react';
import { TimePicker } from 'antd';

const CustomTimePicker = (props) => {
  const {
    onChange,
  } = props;

  return <TimePicker popupClassName="custom-time-picker" showNow={false} format="h:mm a" {...props} onSelect={onChange} />;
}

export default CustomTimePicker;
